import { Directive } from '@angular/core';

@Directive({
    selector: '[xngBreadcrumbItem]',
    standalone: false
})
export class BreadcrumbItemDirective {
  constructor() {}
}
